<template>
  <div id="path-component">
    <b-breadcrumb>
      <b-breadcrumb-item
        v-for="path in paths"
        :key="path.name"
        :text="path.name"
        :active="path.active"
        @click="!path.active ? pushPage(path.path) : null"
      />
    </b-breadcrumb>
  </div>
</template>

<script>
export default {
    name: "PathComponent",
    props: {
        paths: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {
        pushPage(route) {
            this.$router.push({
                name: route
            });
        }
    }
};
</script>

<style scoped></style>
